import React from "react";
import { useSelector } from "react-redux";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import StaffListingMobile from "./StaffListingMobile";

const CommonMobTb = (props) => {
  const {
    tbData,
    tbColumns,
    tbPaignation,
    isPage,
    setIsPage,
    setModValues,
    userInfoData,
    handleDelete,
    isStaff,
  } = props || {};

  const { staffLeavesLoading } = useSelector((state) => state.api);

  return (
    <>
      <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile mt30">
        {staffLeavesLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={tbData}
            tableColumns={tbColumns}
            tablePagination={tbPaignation}
            isPage={isPage}
            setIsPage={setIsPage}
            isFirstColSticky={true}
          />
        )}
      </div>

      <div className="lead-logs-card-container leave-management-mobile-v only-mobile">
        {staffLeavesLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <StaffListingMobile
            tableData={tbData}
            setModValues={setModValues}
            tablePagination={tbPaignation}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            isLeadLoading={staffLeavesLoading}
            userInfoData={userInfoData}
            handleDelete={handleDelete}
            isStaff={isStaff}
          />
        )}
      </div>
    </>
  );
};

export default CommonMobTb;
